// Utility function to calculate margin
export const calculateMargin = (order) => {
  if (!order?.items || order.items.length === 0) return 0;

  // Calculate purchase total
  let purchaseTotal = 0;
  for (const item of order.items) {
    if (!item.purchasePrice || item.purchasePrice === 0) {
      return "Purchase price is not correct in order";
    }
    purchaseTotal += item.purchasePrice * (item.quantity || 0);
  }
  let buyBackTotal = 0;
  for (const item of order.buyBackItems) {
    if (!item.subtotal || item.subtotal === 0) {
      return "Purchase price is not correct in order";
    }
    buyBackTotal += item.subtotal;
  }

  // Safe defaults for charges
  const orc = order.orc || 0;
  const bg = order.bgAmount || 0;
  const emdInterest = order.emdInterest || 0;
  const gemCharges = order.gemCharges || 0;
  const freight = order.freightCharges || 0;
  const install = order.installationCharges || 0;

  // Subtotal should already exclude tax
  const subtotal = order.subtotal || 0;

  const margin =
    subtotal -
    purchaseTotal -
    orc -
    freight -
    bg -
    emdInterest -
    gemCharges -
    install +
    buyBackTotal;
  return margin;
};

export const calculateActualMargin = (order) => {
  if (!order?.items || order.items.length === 0) return 0;

  // Calculate purchase total
  let purchaseTotal = 0;
  for (const item of order.items) {
    if (!item.purchasePrice || item.purchasePrice === 0) {
      return "Purchase price is not correct in order";
    }
    purchaseTotal += item.actualPurchase ? item.actualPurchase * (item.quantity || 0) : item.purchasePrice * (item.quantity || 0);
  }
  let buyBackTotal = 0;
  for (const item of order.buyBackItems) {
    if (!item.subtotal || item.subtotal === 0) {
      return "Purchase price is not correct in order";
    }
    buyBackTotal += item.subtotal;
  }

  // Safe defaults for charges
  const orc = order.orc || 0;
  const bg = order.bgAmount || 0;
  const emdInterest = order.emdInterest || 0;
  const gemCharges = order.gemCharges || 0;
  const freight = order.freightCharges || 0;
  const install = order.installationCharges || 0;

  // Subtotal should already exclude tax
  const subtotal = order.subtotal || 0;

  const margin =
    subtotal -
    purchaseTotal -
    orc -
    freight -
    bg -
    emdInterest -
    gemCharges -
    install +
    buyBackTotal;
  return margin;
};

export function decodeBase64UrlSafe(str) {
  const base64 = str
    .replace(/-/g, "+")
    .replace(/_/g, "/")
    .padEnd(str.length + ((4 - (str.length % 4)) % 4), "=");
  const json = decodeURIComponent(escape(atob(base64)));
  return JSON.parse(json);
}
export function encodeBase64UrlSafe(obj) {
  return btoa(unescape(encodeURIComponent(JSON.stringify(obj))))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, ""); // Optional: Remove trailing "="
}

export const toIST = (date) => {
  if (!date) return null; // allow clearing
  return new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
};

export const formatINR = (value) =>
  Number(value ?? 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
